<template>
	<div
		class="table-row"
		:class="{
			[`table-row-${index} table-row-${item.key}`]: true,
			'fixed-selection': isFixedSelection,
			disabled,
		}"
		@click="onClickRow"
	>
		<div class="table-cell selector" v-if="selection">
			<Checkbox
				v-if="!isFixedSelection"
				:value="selected"
				:disabled="disabled"
				@click="onClickSelect"
				:key="`checkbox-${item.key}-${selected}`"
			/>
		</div>
		<div
			v-for="col in columns"
			:key="col.field"
			:class="{ ...col.cellClasses, 'table-cell': true }"
			:style="col.styles"
		>
			<div class="table-cell-content">
				<div class="flex-wrapper">
					<slot :column="col" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Checkbox } from '@/components/common'
export const SELECTION_FIXED = 'fixed'

export default {
	name: 'TableRow',
	components: { Checkbox },
	props: {
		index: Number,
		item: null,
		selection: { type: Boolean, default: null },
		selectOnRowClick: { type: Boolean, default: null },
		selected: { type: [Boolean, String], default: null },
		columns: { type: Array, default: () => [] },
		disableAdditionalSelection: { type: Boolean, default: null },
	},
	computed: {
		disabled() {
			return this.selection && !this.selected && this.disableAdditionalSelection
		},
		isFixedSelection() {
			return this.selection && this.selected === SELECTION_FIXED
		},
	},
	methods: {
		onClickSelect(e) {
			if (this.selection && this.selected !== SELECTION_FIXED) {
				e?.stopPropagation()
				this.$attrs.onSelection(this.item)
			}
		},
		onClickRow(e) {
			if (this.selectOnRowClick) {
				this.onClickSelect(e)
			}
			this.$emit('row-click', this.item.data, e)
		},
	},
	emits: ['row-click'],
}
</script>

<style lang="scss" scoped>
.table-row {
	.table-cell {
		.table-cell-content {
			height: 100%;

			.flex-wrapper {
				height: 100%;
				display: flex;
				align-items: center;
			}
		}
	}
}
</style>
